
import { useDiscrepancyManagement } from "@/hooks/useDiscrepancyManagement";
import { DiscrepancyItem } from "./discrepancy/DiscrepancyItem";
import { JustificationDialog } from "./discrepancy/JustificationDialog";
import { useState } from "react";
import { Discrepancy } from "@/types/discrepancy";
import { TablePagination } from "@/components/ui/data-table/TablePagination";

export const DiscrepancyManager = () => {
  const { discrepancies, handleStatusUpdate } = useDiscrepancyManagement();
  const [selectedDiscrepancy, setSelectedDiscrepancy] = useState<Discrepancy | null>(null);
  const [isJustificationDialogOpen, setIsJustificationDialogOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleJustifiedClick = (discrepancy: Discrepancy) => {
    setSelectedDiscrepancy(discrepancy);
    setIsJustificationDialogOpen(true);
  };

  // Afficher toutes les différences, y compris celles en attente
  const filteredDiscrepancies = discrepancies;

  // Calculate pagination
  const totalPages = Math.ceil(filteredDiscrepancies.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = filteredDiscrepancies.slice(startIndex, endIndex);

  return (
    <div className="space-y-4">
      {currentItems.map((discrepancy) => (
        <DiscrepancyItem
          key={discrepancy.id}
          discrepancy={discrepancy}
          onStatusUpdate={handleStatusUpdate}
          onJustifiedClick={handleJustifiedClick}
        />
      ))}

      {totalPages > 1 && (
        <TablePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}

      <JustificationDialog
        open={isJustificationDialogOpen}
        onOpenChange={setIsJustificationDialogOpen}
        discrepancy={selectedDiscrepancy}
        onSubmit={(explanation) => {
          if (selectedDiscrepancy) {
            handleStatusUpdate(selectedDiscrepancy.id, "justified", explanation);
          }
          setIsJustificationDialogOpen(false);
        }}
      />
    </div>
  );
};
